// eslint-disable-next-line jira/export/no-external-exports
export { toggleSelectedIssues } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/roadmap/scope/issues/actions';

// eslint-disable-next-line jira/export/no-external-exports
export type { ToggleSelectedIssuesActionPayload } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/roadmap/scope/issues/actions';

// eslint-disable-next-line jira/export/no-external-exports
export { TargetTypes } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/roadmap/scope/issues/selectable-issue/actions';
